module.exports = __webpack_public_path__ + "img/between_the_sheets.f9e828df.jpg";